<div class="container mx-auto mt-16 mb-32 max-w-screen-xl">
  <div class="flex justify-center p-8 lg:hidden">
    <img src="assets/evc/img/not-found/mobile.svg" [alt]="'errors.page.notFound.title' | translate" />
  </div>

  <div class="block lg:flex p-4 lg:p-16 justify-center">
    <div class="lg:max-w-4xl lg:py-16 self-center">
      <div class="text-primary text-7xl leading-none font-display font-bold text-left md:text-center lg:text-left">
        <span [innerHTML]="'errors.page.notFound.title' | translate"> </span>
      </div>
      <div class="opacity-90 leading-loose text-3xl py-14 text-left md:text-center lg:text-left">
        <span>{{ "errors.page.notFound.description" | translate }}</span>
      </div>
      <div class="block sm:flex md:max-w-4xl md:m-auto">
        <button class="btn-primary w-full" (click)="goBack()">
          {{ "errors.page.notFound.goBack" | translate }}
        </button>
        <div class="start-again-button" (click)="startAgain()">
          <span>{{ "errors.page.notFound.startAgain" | translate }}</span>
          <img src="assets/general/img/arrow-right.svg" [alt]="'errors.page.notFound.startAgain' | translate" />
        </div>
      </div>
    </div>
    <div class="hidden lg:block p-16 self-center">
      <img [src]="getImageUrl()" [alt]="'errors.page.notFound.title' | translate" width="350" />
    </div>
  </div>
</div>
